import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { Box, Flex, Copy, themeColor } from '@elparking/components'
import { SPEED_CHARGING_FAST, SPEED_CHARGING_SEMIFAST, SPEED_CHARGING_SLOW } from 'commons/js/constants'

import { bySpeedChargingTypeDesc } from './comparators'
import messages from './messages'

const SpeedChargingContainer = styled(Box)`
    height: 24px;
    border: 1px solid ${themeColor('gray40')};
    display: inline-flex;
`

const BorderLeftBox = styled(Box)`
    border-left: 1px solid ${themeColor('gray40')};
`

export const speedChargingOptionsMap = {
    [SPEED_CHARGING_FAST]: {
        speedTypeName: <FormattedMessage defaultMessage='Carga rápida' />,
        speedTypeImage: '/images/electric-charge/fast_charge_icon.webp',
    },
    [SPEED_CHARGING_SEMIFAST]: {
        speedTypeName: <FormattedMessage defaultMessage='Carga semirrápida' />,
        speedTypeImage: '/images/electric-charge/semifast_charge_icon.webp',
    },
    [SPEED_CHARGING_SLOW]: {
        speedTypeName: <FormattedMessage defaultMessage='Carga lenta' />,
        speedTypeImage: null,
    },
}

function ChargingPointSpeed ({ maxPower, plugs }) {
    const intl = useIntl()
    const speedType = getMaxSpeedFromPlugs(plugs)

    if (!speedType) {
        return null
    }
    return (
        <SpeedChargingContainer my='8px'>
            <Flex alignItems='center' px='8px' py='4px'>
                { speedType.speedTypeImage && <img src={speedType.speedTypeImage} /> }
                <Copy padding={speedType.speedTypeImage ? '0 0 0 8px' : '0'} fontSize='xxxSmall' transform='uppercase' fontWeight='medium'>
                    {speedType.speedTypeName}
                </Copy>
            </Flex>
            <BorderLeftBox px='8px' py='4px'>
                <Copy title={intl.formatMessage(messages.maxPowerTitle)} padding='0' fontSize='xxxSmall' fontWeight='medium'>
                    {maxPower} kW
                </Copy>
            </BorderLeftBox>
        </SpeedChargingContainer>
    )
}

export function getMaxSpeedFromPlugs (plugs) {
    const [ maxChargingSpeedPlug = {} ] = plugs.slice().sort(bySpeedChargingTypeDesc)
    const { speedChargingType: maxSpeedChargingType } = maxChargingSpeedPlug

    return speedChargingOptionsMap[maxSpeedChargingType] || null
}

ChargingPointSpeed.propTypes = {
    plugs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        slug: PropTypes.string,
        speedChargingType: PropTypes.number,
    })),
    maxPower: PropTypes.number,
}

export default ChargingPointSpeed
